import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import defaultPicture from './images/default.png';
import { AspectRatio } from 'theme-ui';

const DirectoryCard = (props) => {

  const [isHovered, setIsHovered] = useState(false);

  const cardStyle = {

    backgroundColor: '#D5B3E7',
    border: isHovered ? '1px solid #6E4884' : '1px solid #d5b3e7',
    borderRadius: '20px',
    boxShadow: isHovered ? '5px 5px 15px grey' : '0 4px 12px rgba(0, 0, 0, 0.2)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    padding: '5px 10px 25px 10px',
    AspectRatio: '1/1',
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
    textAlign: 'center',
    fontWeight: 'bold',
    fontFamily: 'Poppins',
    color: '#6E4884',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',

  };
  
  const pictureStyle = {
    width: '120px', 
    height: '120px',
    position: 'absolute',
    top: '17px', 
    left: '50%',
    transform: 'translateX(-50%)',
    border: '1px solid #6E4884',
    borderRadius: '50%',
    boxShadow: '0 3px 10px rgba(0, 0, 0, 0.2)',
    objectFit: 'cover',
  };
  
  const textContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '140px',
  };
  
  const nameStyle = {
    fontSize: '1.7em',
    margin: '0',
    padding: '0.1em 0.1em 0.2em',
    minHeight: '40px',
    color: 'black',
  };
  
  const roleStyle = {
    fontSize: '1.1em',
    padding: '0.1em 0.15em',
    margin: '0',
    minHeight: '30px',
    color: 'black',
  };

  // "https://lh3.googleusercontent.com/a/ACg8ocK0gQvjuPxYtFwteByMOul4TvuxNy-ylSbakenf0sOaMpopWVv8=s400-c"

  // "https://firebasestorage.googleapis.com/v0/b/wics-portal-417412.appspot.com/o/profile-pictures%2F9L1V85xEDWhiwXhI71ZTCDtAxqy2%2Fheadshot.jpg?alt=media&token=11df7b33-eefd-4382-ad72-46f6186d6915"

  const isDefaultPhoto = props.photo && props.photo.startsWith("https://lh3.googleusercontent.com/");

  const handleClick = () => {
    props.openPanel({
      displayName: props.displayName,
      classYear: props.classYear,
      concentration: props.concentration,
      photo: isDefaultPhoto ? defaultPicture : props.photo,
      email: props.email,
      linkedin: props.linkedin,
      instagram: props.instagram,
      role: props.role,
      bio: props.bio,
      companies: props.companies,
      interests: props.interests,
      courses: props.courses,
      coursesTaught: props.coursesTaught,
    });
  };

  return (

    <div style={cardStyle} onClick={handleClick} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
        <img src={isDefaultPhoto ? defaultPicture : props.photo}  alt={"Profile picture"} style={pictureStyle} />
        <div style={textContainerStyle}>

          <h1 style={nameStyle}>{props.displayName}</h1>
          <h1 style={roleStyle}>{props.classYear ? ("Class of " + (props.classYear)) : ("Harvard College")}</h1>
          <h1 style={roleStyle}>
            {Array.isArray(props.concentration) 
              ? props.concentration.join(', ') 
              : (props.concentration || "Student")}
          </h1>

        </div>
    </div>

  );
};

export default DirectoryCard;